import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { PlaceFeatureGroup } from '../../../features/places-features.constants'
import { getFeaturesByGroup } from '../../../features/places-features.rules'
import { PlaceFeatureExtraCard } from '../../flags/place-feature-group'
import * as S from './access-control-tab.styled'

type SplitPart = 'branches' | 'root' | undefined

interface AccessControlClassicLayoutProps {
  renderGroup: (
    group: PlaceFeatureGroup,
    splitPart: SplitPart,
    extraCards?: PlaceFeatureExtraCard[],
  ) => ReactNode
}

const SMART_HOME_SIZE = getFeaturesByGroup(PlaceFeatureGroup.smartHome).filter(
  (feature) => !feature.hidden,
).length

// Note: keyless (the biggest card) leads, the provider cards and Smart home follow by size
export const AccessControlClassicLayout = ({ renderGroup }: AccessControlClassicLayoutProps) => {
  const { t } = useTranslation(['organisation'])
  const smartHome: PlaceFeatureExtraCard = {
    key: PlaceFeatureGroup.smartHome,
    node: renderGroup(PlaceFeatureGroup.smartHome, undefined),
    size: SMART_HOME_SIZE,
    title: t('organisation:places.features.groups.smartHome'),
  }

  return (
    <S.ClassicLayout>
      <S.LeadColumn>{renderGroup(PlaceFeatureGroup.keyless, 'root')}</S.LeadColumn>
      <S.RestGrid>{renderGroup(PlaceFeatureGroup.keyless, 'branches', [smartHome])}</S.RestGrid>
    </S.ClassicLayout>
  )
}
